import { recordFromSnapshot } from 'utils/firebaseUtils'
import moment from 'moment'
// ------------------------------------
// Constants
// ------------------------------------
export const CREATE_CUSTOMER_ERROR = 'CREATE_CUSTOMER_ERROR'
export const CREATE_CUSTOMER_SUCCESS = 'CREATE_CUSTOMER_SUCCESS'
export const DELETE_CUSTOMER_ERROR = 'DELETE_CUSTOMER_ERROR'
export const DELETE_CUSTOMER_SUCCESS = 'DELETE_CUSTOMER_SUCCESS'
export const UPDATE_CUSTOMER_ERROR = 'UPDATE_CUSTOMER_ERROR'
export const UPDATE_CUSTOMER_SUCCESS = 'UPDATE_CUSTOMER_SUCCESS'
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER'

// ------------------------------------
// Logic Actions
// ------------------------------------
export function selectCustomer(customer) {
  return (dispatch, getState) => {
    dispatch({
      type: SELECT_CUSTOMER,
      payload: customer
    })
  }
}

// ------------------------------------
// Basic Actions
// ------------------------------------

export function createCustomer(c) {
  return (dispatch, getState) => {
    const { firebase, auth } = getState()
    const now = moment().format()
    const newCustomer = {
      createdBy: auth.hbUserKey,
      updatedBy: auth.hbUserKey,
      createdAt: now,
      updatedAt: now,
      customers_id: null,
      customers_last_name: c.customers_last_name,
      customers_first_name: c.customers_first_name,
      customers_email: c.customers_email,
      customers_phone_number: c.customers_phone_number,
      isMember: c.isMember,
      expirationDate: c.expirationDate
        ? moment(c.expirationDate).format()
        : null
    }
    firebase.child('customers').push(newCustomer, error => {
      if (error) {
        console.error('ERROR @ createCUSTOMER :', error)
        dispatch({
          type: CREATE_CUSTOMER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function updateCustomer(customer, changes) {
  return (dispatch, getState) => {
    const { firebase, auth } = getState()
    changes.updatedBy = auth.hbUserKey
    changes.updatedAt = moment().format()
    firebase.child('customers/' + customer.key).update(changes, error => {
      if (error) {
        console.error('ERROR @ updateCustomer :', error)
        dispatch({
          type: UPDATE_CUSTOMER_ERROR,
          payload: error
        })
      }
    })
  }
}

export function registerCustomersListeners() {
  return (dispatch, getState) => {
    const { firebase } = getState()
    const ref = firebase.child('customers')

    ref.on('child_added', snapshot => {
      const payload = recordFromSnapshot(snapshot)
      dispatch({
        type: CREATE_CUSTOMER_SUCCESS,
        payload: payload
      })
    })
    ref.on('child_changed', snapshot => {
      const payload = recordFromSnapshot(snapshot)
      dispatch({
        type: UPDATE_CUSTOMER_SUCCESS,
        payload: payload
      })
    })
    ref.on('child_removed', snapshot =>
      dispatch({
        type: DELETE_CUSTOMER_SUCCESS,
        payload: recordFromSnapshot(snapshot)
      })
    )
  }
}

export const actions = {
  createCustomer,
  updateCustomer,
  registerCustomersListeners
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [CREATE_CUSTOMER_SUCCESS]: (state, action) => {
    let list
    let tmpList = state.list.slice()
    tmpList = tmpList.filter(customer => customer.key === action.payload.key)
    if (tmpList.length === 0) {
      list = [...state.list, action.payload]
    } else {
      list = [...state.list]
    }
    return Object.assign({}, state, { list: list })
  },
  [CREATE_CUSTOMER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [UPDATE_CUSTOMER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.map(customer => {
        return customer.key === action.payload.key ? action.payload : customer
      })
    }),
  [UPDATE_CUSTOMER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [DELETE_CUSTOMER_SUCCESS]: (state, action) =>
    Object.assign({}, state, {
      list: state.list.filter(customer => {
        return customer.key !== action.payload.key
      })
    }),
  [DELETE_CUSTOMER_ERROR]: (state, action) =>
    Object.assign({}, state, { error: action.payload }),
  [SELECT_CUSTOMER]: (state, action) =>
    Object.assign({}, state, { selectedCustomer: action.payload })
}
// ------------------------------------
// Reducer
// ------------------------------------
const initialState = { list: [], selectedCustomer: {} }
export default function tableReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/redux/modules/customer.js